<template>
  <el-container>
    <el-main class="CalendarLayout" style="background-color: #fff;">
      <div class="cal-wrap">
        <el-form  v-if="timeList.length != 0">
          <div class="blockDate">
            <div class="date">访谈日期</div>
            <div class="timeBlock">
                <div style="display: inline-block;margin-right: 20px" v-for="(item, itemIndex) in timeList" :key="itemIndex" @click="getDate(item.InterviewDate)">
                  <el-radio v-model="radio2" :label="itemIndex" border size="medium" class="myradio">{{item.InterviewDate}}
                    <span class="residue" v-if="item.RestCount!=0">剩余{{item.RestCount}}</span>
                    <span class="residue" v-if="item.RestCount==0">候补{{item.QueueCount}}</span>
                  </el-radio>
                </div>
            </div>
          </div>
          <div class="block">
            <span class="demonstration">访谈时段</span>
            <el-radio v-model="radio" label="1">上午</el-radio>
            <el-radio v-model="radio" label="2">下午</el-radio>
            <el-radio v-model="radio" label="3">晚上</el-radio>
          </div>
          <div class="timeBlock" v-show="radio == '1'">
            <el-radio v-model="radio3" :label="itemIndex" border size="medium" class="myradio" v-for="(item, itemIndex) in timeList[radio2].SW" :key="itemIndex">
              {{item.From}}-{{item.To}}
              <span class="residue" v-if="item.RestCount!=0">剩余{{item.RestCount}}</span>
              <span class="residue" v-if="item.RestCount==0">候补{{item.QueueCount}}</span>
            </el-radio>
          </div>
          <div class="timeBlock" v-show="radio == '2'">
            <el-radio v-model="radio3" :label="itemIndex" border size="medium" class="myradio" v-for="(item, itemIndex) in timeList[radio2].XW" :key="itemIndex">
              {{item.From}}-{{item.To}}
              <span class="residue" v-if="item.RestCount!=0">剩余{{item.RestCount}}</span>
              <span class="residue" v-if="item.RestCount==0">候补{{item.QueueCount}}</span>
            </el-radio>
          </div>
          <div class="timeBlock" v-show="radio == '3'">
            <el-radio v-model="radio3" :label="itemIndex" border size="medium" class="myradio" v-for="(item, itemIndex) in timeList[radio2].WS" :key="itemIndex">
              {{item.From}}-{{item.To}}
              <span class="residue" v-if="item.RestCount!=0">剩余{{item.RestCount}}</span>
              <span class="residue" v-if="item.RestCount==0">候补{{item.QueueCount}}</span>
            </el-radio>
          </div>
          <div v-if="haveInterview == 1" class="prompt">
            您已预约访谈，取消访谈后才可再次预约！
          </div>
          <div v-else-if="needInterview == 0" class="prompt">
            您无需访谈，不可预约访谈！
          </div>
          <div class="buttonBlock">
            <el-button type="primary" @click="reserveInterview()"  :disabled="needInterview == 0 || haveInterview == 1">立即预约</el-button>
            <el-button @click="backReturn()">取 消</el-button>
          </div>
        </el-form>
          <div v-if="timeList.length == 0" class="noAppointment">
              <div>最近没有可预约的访谈排班！</div>
          </div>
        <!-- 弹窗展示 -->
        <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
          <span>{{this.Global.realName}}同学，您好！您已成功预约{{this.year}}年{{month}}月{{day}}日{{addInterview.From}}-{{addInterview.To}}的会谈，请选择安全、安静的环境，在会谈前
            5分钟登录腾讯会议室({{this.TencentNo}})。
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog()">知道了，关闭</el-button>
          </span>
        </el-dialog>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  mounted() {
    this.load(this.Global.userID);
    this.loadNeedInterview(this.Global.userID);
    this.loadMyInterview(this.Global.userID);
  },
  data() {
    return {
      year:'',
      month:'',
      day:'',
      selectDate:'',
      radio: '1',
      radio2: 0,
      radio3: 0,
      UserID:this.Global.userID,
      TencentNo:0,
      Flag:0,
      timeList:[],
      needInterview:1,
      haveInterview:0,
      addInterview:{
        From: "12:00",   //访谈开始时间
        InterviewDate: "2023-05-01",    //访谈日期
        To: "14:00",  //访谈结束时间
        UserID: this.Global.userID,    //学员id
        Type:1,   // 访谈预约类型   1-预约访谈  2-候选排队
        SourceNo:"",  //来源id
      }
    };
  },
  props: {
    showToday: {
      type: Boolean,
      default: true, //是否显示返回今天按钮
    },
  },
  methods: {
    closeDialog(){
      this.centerDialogVisible = false;
      location.reload();// 刷新页面
    },
    centerDialog(){
      this.$router.push('/Measurement/AppointmentRecord')
    },
    load(UserID) {//列表
      this.$Http_Post('HomePage/QueryInterviewDateList', {UserID:UserID}).then((res) => {
        if (res.Code == 0) {
          this.timeList = res.Data.List;
          this.selectDate = res.Date.List[0].InterviewDate;
          this.Flag = res.Data.Flag;
        }
      });
    },
    loadNeedInterview(UserID) {//列表
      this.$Http_Post('HomePage/CheckInterviewState', {UserID:UserID}).then((res) => {
        if (res.Code == 0) {
          this.needInterview = res.Data.NeedInterview;
          this.addInterview.SourceNo =  res.Data.SourceNo;
        }
      });
    },
    loadMyInterview(UserID) {//列表
      this.$Http_Post('HomePage/QueryInterviewList', {UserID:UserID}).then((res) => {
        if (res.Code == 0) {
          this.haveInterview = res.Data.Flag;
          if (res.Data.Flag == 1){
            let list = res.Data.List;
            for (let i = 0; i < list.length; i++) {
              if (list[i].Status == "1") {
                this.TencentNo = list[i].TencentNo;
              }
            }
          }
        }
      });
    },
    reserveInterview() {//处理请求数据
      var selectItem;
      switch (this.radio) {
        case "1":selectItem = this.timeList[this.radio2].SW[this.radio3];
        break;
        case "2":selectItem = this.timeList[this.radio2].XW[this.radio3];
        break;
        case "3":selectItem = this.timeList[this.radio2].WS[this.radio3];
        break;
      }
      this.addInterview.From = selectItem.From;
      this.addInterview.InterviewDate = selectItem.InterviewDate;
      this.addInterview.To = selectItem.To;
      if(selectItem.RestCount > 0){
        this.addInterview.Type = 1;
      }else {
        this.addInterview.Type = 2;
      }
      this.$Http_Post('HomePage/ReserveInterview', this.addInterview).then((res) => {
        if (res.Code == 0) {
          if(this.addInterview.Type == 1){
            const data = this.addInterview.InterviewDate.split('-');
            this.year  = data[0];
            this.month = data[1];
            this.day   = data[2];
            this.loadMyInterview(this.Global.userID);
            this.centerDialogVisible = true;
          }
          if(this.addInterview.Type == 2){
            this.Global.request_successful("候补成功");
          }
        }else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    backReturn(){
      this.$router.go(-1);
    },
    getDate(date){
      this.selectDate = date;
    }
  },
}
</script>
<style>
.CalendarLayout .demonstration {
  color: #666;
  padding-right: 12px;
  display: inline-block;
}
.CalendarLayout .block {
  padding-bottom: 15px;
}
.CalendarLayout .blockDate {
  padding-bottom: 15px;
}
.CalendarLayout .blockDate .date {
  color: #666;
  padding: 0px;
  padding-top: 18px;
}
.CalendarLayout .blockDate .timeBlock {
  padding-left: 70px;
  margin-top: -36px;
  padding-bottom: 10px;
}
.CalendarLayout .el-radio__label {
  padding: 0px;

}
.timeBlock .el-radio__input.is-checked+.el-radio__label {
    color: #fff;
}
.el-radio.is-bordered+.el-radio.is-bordered {
  margin-left: 0px;
}
.CalendarLayout .el-radio--medium.is-bordered {
  padding: 0 0 0 8px;
  border-radius: 4px;
  height: 36px;
  border: 1px solid #aaa;
}
.CalendarLayout .timeBlock .residue {
  display: inline-block;
  width: 55px;
  padding: 10px 8px;
  margin-left: 6px;
  border-radius: 0px 4px 4px 0px;
  background-color: #fff;
  color: #666;
  border-left: 1px solid #aaa;
}
.CalendarLayout .timeBlock .is-checked {
    background-color: #0088ff;
    border: 1px solid #0088ff;
    color: #fff;
}
.CalendarLayout .timeBlock .is-checked  .residue {
  background-color: #0d78e3;
  border-left: 1px solid #0d78e3;
  color: #fff;
}
.CalendarLayout .timeBlock .is-disabled  .residue {
  background-color: #ccc;
  color: #fff;
}
.CalendarLayout .myradio .el-radio__inner {
  display: none;
  margin: 0;
}
.CalendarLayout .myradio {
  margin-top: 15px;
}
.CalendarLayout .timeBlock {
  padding-left: 70px;
  padding-bottom: 10px;
}
.CalendarLayout .prompt {
  color: #f30000;
  padding-top: 30px;
  padding-left: 70px;
}
.CalendarLayout .buttonBlock {
  padding-top: 10px;
  padding-left: 70px;
}
.cal-wrap .noAppointment {
    border: 1px solid rgba(222, 222, 222, 1);
    border-radius: 4px;
    font-size: 17px;
    color: #666;
    text-align: center;
    width: 100%;
    padding: 30px;
    float: left;
    margin-left: 20px;
    margin-top: 20px;
}
</style>
